import Layout from "@/components/Layout";
import { EXTERIOR_SKETCH } from "@/lib/constants";

export default function GalleriaPage() {
  return (
    <Layout>
      <section className="relative" data-testid="galleria-fullscreen">
        {/* Full-screen background image */}
        <div className="relative w-full" style={{ minHeight: "calc(100vh - 120px)" }}>
          <img
            src={EXTERIOR_SKETCH}
            alt="Ristorante Pedrocchi — illustrazione"
            className="absolute inset-0 w-full h-full object-cover"
          />
          {/* Soft overlay so the text remains readable */}
          <div className="absolute inset-0 bg-paper/55" />

          {/* Centered text */}
          <div className="relative z-10 flex flex-col items-center justify-center text-center px-6"
               style={{ minHeight: "calc(100vh - 120px)" }}>
            <div className="bg-paper/95 border border-ink px-10 py-12 md:px-16 md:py-16 max-w-2xl backdrop-blur-sm">
              <div className="overline mb-6">Galleria</div>
              <h1 className="font-serif text-4xl md:text-6xl leading-tight">
                Pagina <em className="text-wine">in aggiornamento</em>
              </h1>
              <p className="text-ink-mid mt-8 leading-relaxed">
                Stiamo preparando una raccolta di immagini della nostra storia,
                della cucina e dei momenti speciali del locale. Torna presto.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
